// Keenthemes' plugins
window.KTUtil = require('@/src/js/components/util.js');
window.KTCookie = require('@/src/js/components/cookie.js');
window.KTDialer = require('@/src/js/components/dialer.js');
window.KTDrawer = require('@/src/js/components/drawer.js');
window.KTEventHandler = require('@/src/js/components/event-handler.js');
window.KTFeedback = require('@/src/js/components/feedback.js');
window.KTImage = require('@/src/js/components/image-input.js');
window.KTMenu = require('@/src/js/components/menu.js');
window.KTPasswordMeter = require('@/src/js/components/password-meter.js');
window.KTPlace = require('@/src/js/components/place.js');
window.KTScroll = require('@/src/js/components/scroll.js');
window.KTScrolltop = require('@/src/js/components/scrolltop.js');
window.KTSearch = require('@/src/js/components/search.js');
window.KTStepper = require('@/src/js/components/stepper.js');
window.KTSticky = require('@/src/js/components/sticky.js');
window.KTToggle = require('@/src/js/components/toggle.js');

// Layout base js
window.KTApp = require('@/src/js/layout/app.js');
window.KTLayoutAside = require('@/src/js/layout/aside.js');
window.KTLayoutExplore = require('@/src/js/layout/explore.js');
window.KTLayoutSearch = require('@/src/js/layout/search.js');
window.KTLayoutToolbar = require('@/src/js/layout/toolbar.js');
